/*global DM, _DM*/
(function () {
    'use strict';

    var dmDeferred;

    function dmAsyncInit() {
        DM.init({apiKey: '', status: false, cookie: false});
        dmDeferred.resolve();
    }

    function initDailyMotion() {
        if (!dmDeferred) {
            dmDeferred = $.Deferred();

            if (typeof window._DM === 'undefined') {
                window.dmAsyncInit = dmAsyncInit;

                var e = document.createElement('script');
                e.async = true;
                e.src = 'https://api.dmcdn.net/all.js';

                var s = document.getElementsByTagName('script')[0];
                s.parentNode.insertBefore(e, s);
            }
        }

        return dmDeferred.promise();
    }

    window.hpDailyMotion = $.extend(window.hpDailyMotion || {}, {
        apiReady: initDailyMotion
    });
}) ();
